import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 text-center">404 - Page Not Found</h1>
      <p className="text-base sm:text-lg text-gray-600 mt-4 text-center">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <p className="mt-6">
        <Link
          to="/"
          className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 text-base sm:text-lg"
        >
          Go back to Home
        </Link>
      </p>
    </div>
  );
};

export default ErrorPage;
